export default function  Footer() {
    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        2024 © JustFood.
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            Design & Develop by DIGITALWEB
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}